'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessagesPageUri = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessagesPageUri = exports.getMessagesPageUri = (0, _get2.default)('messagesPageUri');


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getMessagesPageUri.js
// module id = 1168
// module chunks = 2 3